import React from "react";
import ReactDOM from "react-dom";
import App from "./app";
import "normalize.css";
import "./styles/index.css";
import 'react-perfect-scrollbar/dist/css/styles.css';

ReactDOM.render(<App />, document.getElementById("root"));
